import React from "react";
import "../Loader/loader.css";

const Loader = () => {
    return (
        <div className="loader-overlay">
            <div className="spinner"></div>
        </div>
    );
};

export default Loader;
